export default __webpack_public_path__ + "static/media/calendar.aee4cc76.svg";